import { FormattedMessage, defineMessages } from 'react-intl';

import { AveragePlayerScore } from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';

import { BreakdownIcon } from 'atoms/icons/BreakdownIcon';

type Props = {
  score: AveragePlayerScore;
};

enum ScoreType {
  ALL_AROUND = 'ALL_AROUND',
  DECISIVE = 'DECISIVE',
}

const initials = {
  [ScoreType.ALL_AROUND]: 'AA',
  [ScoreType.DECISIVE]: 'D',
};

const scoreTypeLabels = defineMessages<ScoreType>({
  [ScoreType.ALL_AROUND]: {
    id: 'breakdown.all_around',
    defaultMessage: 'All around score',
  },
  [ScoreType.DECISIVE]: {
    id: 'breakdown.decisive',
    defaultMessage: 'Decisive score',
  },
});

export const BreakdownLabel = ({ score }: Props) => {
  const scoreType = (() => {
    if (score.includes('ALL_AROUND')) return ScoreType.ALL_AROUND;
    if (score.includes('DECISIVE')) return ScoreType.DECISIVE;
    return null;
  })();
  if (!scoreType) return null;
  return (
    <Horizontal>
      <BreakdownIcon>{initials[scoreType]}</BreakdownIcon>
      <FormattedMessage {...scoreTypeLabels[scoreType]} />
    </Horizontal>
  );
};
